import { NAME_MAX_LENGTH, NAME_MIN_LENGTH } from './constants';
import { validateDigitsExistence } from '@framework/ui/Organisms/FinalForm/validators/validateDigitsExistence';
import { validateMaxLength } from '@framework/ui/Organisms/FinalForm/validators/validateMaxLength';
import { validateMinLength } from '@framework/ui/Organisms/FinalForm/validators/validateMinLength';
import { validateSpecialSymbolsExistence } from '@framework/ui/Organisms/FinalForm/validators/validateSpecialSymbolsExistence';
import { IValidationError } from '../interfaces/ValidationError';

interface IParams {
  value: string | undefined,
  fieldName: string,
  fieldCaption: string,
  firstName?: string,
}

interface IErrorMessages {
  minLength?: (params: { fieldCaption?: string, length: number }) => string,
  maxLength?: (params: { fieldCaption?: string, length: number }) => string,
  invalidError?: (params: { fieldCaption?: string }) => string,
}

export const validateName = (params: IParams, errorMessages?: IErrorMessages): IValidationError => {
  const minLengthError = validateMinLength({ ...params, length: NAME_MIN_LENGTH }, errorMessages?.minLength);
  if (minLengthError) {
    return minLengthError;
  }
  const maxLengthError = validateMaxLength({ ...params, length: NAME_MAX_LENGTH }, errorMessages?.maxLength);
  if (maxLengthError) {
    return maxLengthError;
  }

  if (validateDigitsExistence(params) || validateSpecialSymbolsExistence(params)) {
    return { [params.fieldName]: errorMessages?.invalidError?.(params) ?? `Invalid ${ params.fieldCaption }` };
  }
  // @ts-ignore
  return null;
};
